import {useState} from 'react';
import Select from 'react-select';
import {BsQuestionCircle} from 'react-icons/bs';

import {
  COLOR_EXTRACTED_26,
  COLOR_EXTRACTED_36,
  COLOR_EXTRACTED_45,
  COLOR_EXTRACTED_53,
  COLOR_EXTRACTED_57,
} from 'src/styles/colors';

import './dashboardChartLegend.css';


const Legend = () => {
  return <div className='ImpactBubbleHeaderView__Legend'>
    <span>Low Impact</span>
    {
      [COLOR_EXTRACTED_26, COLOR_EXTRACTED_36, COLOR_EXTRACTED_57, COLOR_EXTRACTED_53, COLOR_EXTRACTED_45].map((v) => {
        return <span className="ImpactBubbleHeaderView__Legend__swatch"key={v} style={{background: v}}></span>;
      })
    }
    <span>High Impact</span>
  </div>;
};
const OPTIONS = [{
  label: 'Classes',
  value: 'Class',
}, {
  label: 'Methods',
  value: 'Method',
}];

const ImpactBubbleHeaderView = ({
  onTypeChanged,
  onTooltipClicked,
}: {
  onTypeChanged: (_: string) => void,
  onTooltipClicked: () => void,
}) => {
  const [selectedType, setSelectedType] = useState('Class');

  return (
    <div className='ImpactBubbleHeaderView'>
      <div style={{
        display: 'flex',
        margin: '0.5rem 5rem 0.5rem 0.5rem',
        alignItems: 'center',
      }}>
        <span
          style={{
            verticalAlign: 'middle',
            lineHeight: '38px',
          }}
        >Showing top 50{' '}
          <div
            style={{
              lineHeight: 1,
              display: 'inline-block',
              margin: '0 0.5rem 0',
            }}
          >
            <Select<{label: string, value: string}>
              options={OPTIONS}
              value={OPTIONS.find((o) => o.value === selectedType)}
              getOptionLabel={({label}) => label}
              getOptionValue={({value}) => value}
              onChange={(data) => {
                const value = data?.value;
                if (value) {
                  onTypeChanged(value);
                  setSelectedType(value);
                }
              }}
            />
          </div>
          {' '}by Impact Score
          <sup className='ImpactBubbleHeaderView__Legend__tooltip'>
            <BsQuestionCircle className="tooltip-icon" id="impactScoreTooltip" onClick={() => onTooltipClicked()} />
          </sup>
        and Incoming Relationships</span>
      </div>
      <Legend />
    </div>
  );
};

export default ImpactBubbleHeaderView;
